import React from 'react';

type Props = {
  academicYear: number | string;
  termNumber: number | null | undefined;
  center: React.ReactNode;
  /** 학년도·학기 타이틀 오른쪽 (TODO 노트 드롭다운 등) */
  afterLabel?: React.ReactNode;
  tutorialAttr?: string;
  /** 이미 플래너 시트 프레임 안(캘린더)이면 외곽 테두리 없이 헤드만 */
  embedded?: boolean;
};

/** 위클리·캘린더 본문 위 — 데일리/TODO와 같은 플래너 시트 섹션 헤드 */
const DashboardPlannerSectionHead: React.FC<Props> = ({
  academicYear,
  termNumber,
  center,
  afterLabel,
  tutorialAttr,
  embedded = false,
}) => {
  const head = (
    <h3 className="cp-dashboard-block__head cp-dash-planner-section-head" data-tutorial-dash={tutorialAttr}>
      <div className="cp-dash-planner-section-head-label">
        <span className="cp-dash-planner-section-head-year">{academicYear}학년도</span>
        {termNumber ? (
          <span className="cp-dash-planner-section-head-term">{termNumber}학기</span>
        ) : null}
      </div>
      {afterLabel}
      <div className="cp-dash-planner-section-head-center" role="group">
        {center}
      </div>
    </h3>
  );
  if (embedded) return head;
  return (
    <div className="cp-dashboard-block cp-dashboard-block--planner-sheet cp-dash-planner-section-head-block">
      {head}
    </div>
  );
};

export default DashboardPlannerSectionHead;
